@for (commentObj of editableComments; track commentObj.id; let i = $index) {
  <div class="single-comment__container">
    <div class="d-flex content__container">
      @if (commentObj?.property?.titleImage) {
        <div class="single-comment__image">
          <img
            src="{{ commentObj?.property?.titleImage?.url }}"
            alt="{{ commentObj?.property?.titleImage?.title }}"
          />
        </div>
      }
      <div class="single-comment__details">
        <div class="row mr0 ml0">
          <div class="col-6 p0">
            <p class="default-m comment-details__name">
              @if (commentObj.fromThirdParty) {
                {{ 'comment.external_comment_l' | translate }}
              } @else {
                {{ commentObj?.agentInfo?.firstName }}&nbsp;{{
                  commentObj?.agentInfo?.name
                }}
              }
            </p>
            <p class="default-s comment-details__excerpt">
              {{ commentObj?.comment }}
            </p>
          </div>
          @if (commentObj?.agentInfo?.id === userId() && allowCommentEdit()) {
            <div class="col-6 p0 d-flex justify-content-end">
              <div
                im-dropdown
                position="block-end"
                (click)="$event.stopPropagation()"
              >
                <button
                  im-icon-button
                  imDropdownTrigger
                  [attr.aria-label]="'general.more_actions_a' | translate"
                >
                  <i class="icon icon--context"></i>
                </button>
                <div imDropdownMenu>
                  <div imDropdownGroup>
                    @if (!commentObj.fromThirdParty) {
                      <button imDropdownItem (click)="editComment(i)">
                        {{ 'comment.edit_a' | translate }}
                      </button>
                    }
                    <button
                      imDropdownItem
                      (click)="onDeleteComment(commentObj.id)"
                    >
                      {{ 'comment.remove_a' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (commentObj.editMode) {
      <div class="col-12 d-flex p12">
        <input
          appInput
          #editCommentInput
          type="text"
          placeholder="{{ 'comment.edit_placeholder_l' | translate }}"
          [value]="commentObj.comment"
          class="form-control"
        />
        <button im-button class="inverted ms-2" (click)="cancelEdit(i)">
          {{ 'CANCEL_A' | translate }}
        </button>
        <button
          im-button
          class="primary ms-2"
          [disabled]="!editCommentInput.value || updatingComment()"
          (click)="onUpdateComment(commentObj, editCommentInput.value)"
        >
          @if (updatingComment()) {
            <im-spinner iconStart class="sm" />
          }
          {{ 'comment.update_a' | translate }}
        </button>
      </div>
    }
    <hr class="m0" />
    <div class="d-flex content__container">
      <div
        class="d-flex align-items-center single-comment__property_details"
        (click)="onShowProperty(commentObj?.property?.id)"
      >
        @if (commentObj?.property) {
          <p class="default-m property-details__name">
            {{ commentObj?.property?.data?.name }}
          </p>
        }
        @if (commentObj?.property?.externalId) {
          <p class="default-s property-details__external-id">
            {{ 'property.external_id_l' | translate }}
            {{ commentObj?.property?.externalId }}
          </p>
        }
        @if (!commentObj?.property) {
          <p class="default-m property-details__name">
            {{ 'comment.contact_list_l' | translate }}
          </p>
        }
      </div>
      <div class="d-flex align-items-center">
        @if (commentObj.updated) {
          <span class="comment-updated">{{
            'comment.updated_l' | translate
          }}</span>
        }
        <p class="default-s comment-details__date">
          {{ commentObj?.updated || commentObj?.created | appDateTime }}
        </p>
      </div>
    </div>
  </div>
}
